import * as Yup from 'yup';

const mainVisualFormValidationSchema = Yup.object().shape({
  langCd: Yup.string().required('언어를 선택해주세요.'),
  bgPath: Yup.array().of(Yup.string()).required('배경 이미지를 첨부해주세요.'),
  mainText: Yup.string().required('메인 텍스트를 입력해주세요.'),
});

export default mainVisualFormValidationSchema;
